module.exports = __webpack_public_path__ + "static/media/joseph-chan-1553994-unsplash.1c84c5e9.jpg";